// ** api slice imports
import { slices } from '../../app/slice';

// ** api routes for mobile application version
const routes = {
  CREATE_MOBILE_APP_VERSION: '/versions/create',
  GET_ALL_MOBILE_APP_VERSIONS: '/versions/list',
  GET_ACTIVE_VERSION: '/versions/active/:platform',
  UPDATE_MOBILE_APP_VERSION: '/versions/update/:id',
  DELETE_MOBILE_APP_VERSION: '/versions/delete/:id',
  CHECK_VERSION_SUPPORT: '/versions/check-support/:platform/:version',
};

// ** slice for mobile application version
const mobileApplicationVersion = slices.injectEndpoints({
  endpoints: builder => ({
    createMobileAppVersion: builder.mutation({
      query: data => ({
        url: routes.CREATE_MOBILE_APP_VERSION,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['MobileVersion'],
    }),
    getAllMobileAppVersions: builder.query({
      query: ({ page, limit, platform, status, search }) => ({
        url: routes.GET_ALL_MOBILE_APP_VERSIONS,
        params: { page, limit, platform, status, search },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getActiveVersion: builder.query({
      query: platform => ({
        url: routes.GET_ACTIVE_VERSION.replace(':platform', platform),
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    updateMobileAppVersion: builder.mutation({
      query: ({ id, data }) => ({
        url: routes.UPDATE_MOBILE_APP_VERSION.replace(':id', id),
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['MobileVersion'],
    }),
    deleteMobileAppVersion: builder.mutation({
      query: id => ({
        url: routes.DELETE_MOBILE_APP_VERSION.replace(':id', id),
        method: 'DELETE',
      }),
      invalidatesTags: ['MobileVersion'],
    }),
    checkVersionSupport: builder.query({
      query: ({ platform, version }) => ({
        url: routes.CHECK_VERSION_SUPPORT.replace(
          ':platform',
          platform
        ).replace(':version', version),
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const {
  useCreateMobileAppVersionMutation,
  useGetAllMobileAppVersionsQuery,
  useGetActiveVersionQuery,
  useUpdateMobileAppVersionMutation,
  useDeleteMobileAppVersionMutation,
  useCheckVersionSupportQuery,
} = mobileApplicationVersion;
